import styled from 'styled-components';
import { Card, Dimmer } from 'semantic-ui-react';

import { Button as ButtonLayoutComponent, Text as TextLayoutComponent } from '@playbookux/playbook-web-core';

export const Container = styled(Dimmer)``;

export const Dialog = styled(Card)`
  &.ui.card {
    display: flex;
    padding: 50px;
    width: 400px;
    background-color: ${({ theme }) => theme.background};
    border-radius: 1px;
    justify-content: space-between;
    align-items: center;

    :after {
      display: none;
    }

    @media screen and (min-width: 420px) {
      padding: 30px;
      height: ${({ isSortedCards }) => (isSortedCards ? '200px' : '180px')};
    }
  }
`;

export const Text = styled(TextLayoutComponent)`
  text-align: center;
`;

export const Content = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  height: 50px;
  flex: 1;
  padding-bottom: 25px;
`;

export const ButtonArea = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 10px;

  @media screen and (min-width: 420px) {
    flex-direction: row;
    gap: 20px;
  }
`;

export const Button = styled(ButtonLayoutComponent)`
  &.ui.button {
    width: 138px;
  }
`;
